import React from "react";
import ComplexPicker from "..";

import { IItemData } from "../common.typing";

import locale from "../../../_util/locale";

export interface IGroupPickerProps {
    /** 组件的标题 */
    title?: string;
    /** 是否为多选 */
    multiple?: boolean;
    /** 数量超出时的提示 */
    limitTips?: string;
    /** 可选的最大数量 */
    maxNum?: number;
    /**
     * 不可用 id
     * 包括 group、user、org
     */
    disabledids?: string[];
    /**
     * 已选择的
     * 包括 group、user、org
     */
    pickedList?: IItemData[];
    /** 必须选择的
     * 包括 group、user、org
     */
    requiredList?: IItemData[];
    /** 获取我的群组列表 */
    getMyGroupList?: () => void;
    /** 我的群组列表 */
    myGroupList?: IItemData[];
    /**
     * 左侧搜索事件
     * key： 关键词
     * rows：加载条数
     */
    loadSearchData: (key: string, rows?: number) => Promise<any>;
    /**
     * 加载更多搜索结果
     * type：类型 - user、group
     * key：关键词
     * row：加载条数，默认 20，赞不支持自定义
     */
    loadSearchDataMore?: (
        type: string,
        key: string,
        rows: number
    ) => Promise<any>;
    /** 关闭组件方法 */
    onClose: () => void;
    /** 点击确定 */
    onConfirm: (ids: string[], length: number) => void;
    /** 是否展示确认按钮的数量 */
    showSelectedNum?: boolean;
    /** 确认按钮是否为 loading 态 */
    isConfirmLoading?: boolean;
    /** 左侧搜索的 placeholder */
    searchPlaceholder?: string;
    /** 是否展示【外部联系人】入口，默认为 false */
    showExternalContact?: boolean;
    // 获取外部联系人列表
    getContactList?: (last_id: number, pageSize: number) => Promise<any>;

    /** 可选总数为 0 时确认按钮可点击，默认为 false */
    canSelectZero?: boolean;
    /** 搜索预留内容区域 */
    mainChildren?: React.ReactNode;
    /** 是否只展示选中的数量,不显示最大数量 */
    justShowSelectedNoMax?: boolean;
    /** 是否禁用标题拖拽 */
    isDisableTitleDrag?: boolean;
    /** 埋点方法 */
    track: (eventName: string, eventData?: any) => void;
}

/**
 * 选择群组
 */
export const GroupPicker: React.FC<IGroupPickerProps> = ({
    onClose,
    onConfirm,
    title = locale("groupPickerTitleDefault"),
    multiple = true,
    limitTips = locale("common_select_overrun"),
    maxNum = 1,
    disabledids,
    pickedList,
    requiredList,
    getMyGroupList,
    myGroupList,
    loadSearchData,
    loadSearchDataMore,
    showSelectedNum = true,
    isConfirmLoading = false,
    searchPlaceholder = locale("searchPlaceholderDefault"),
    showExternalContact,
    getContactList,
    canSelectZero = false,
    mainChildren,
    justShowSelectedNoMax = false,
    isDisableTitleDrag,
    track,
}) => {
    const groupPickerProps = {
        type: "group",
        page: "myGroup",
        searchType: ["group"],
        showGroups: true,
        showRecentSession: false,
        showOrganization: false,
        showPartner: false,
        onClose,
        onConfirm,
        title,
        multiple,
        limitTips,
        maxNum,
        disabledids,
        pickedList,
        requiredList,
        getMyGroupList,
        myGroupList,
        loadSearchData,
        loadSearchDataMore,
        showSelectedNum,
        isConfirmLoading,
        searchPlaceholder,
        showExternalContact,
        getContactList,
        canSelectZero,
        mainChildren,
        justShowSelectedNoMax,
        isDisableTitleDrag,
        track,
    };
    return <ComplexPicker {...groupPickerProps} />;
};

export default GroupPicker;
